import { divide } from "lodash";
import { Calendar, Calendar1, Calendar1Icon } from "lucide-react";
import React from "react";

const BlogRight = () => {
  return (
    <div className="space-y-10">
      <div>
        <p className='text-[20px] mb-4 font-bold'>Search</p>
        <div className="relative w-full lg:w-64">
          <input
            className="w-full p-3 pl-10 rounded-lg focus:outline-none"
            // placeholder="Search Token"
            // onChange={onSearchChanged}
            style={{
              background: 'var(--input-bg)',
              border: '1px solid var(--input-border)',
              color: 'var(--text-primary)'
            }}
          />
          <svg
            className="absolute left-3 top-3.5 w-5 h-5"
            style={{ color: 'var(--text-secondary)' }}
            fill="currentColor"
            viewBox="0 0 18 18"
          >
            <g>
              <path d="M7.75987 15.5197C3.48078 15.5197 0 12.039 0 7.75987C0 3.48078 3.48078 0 7.75987 0C12.039 0 15.5197 3.48078 15.5197 7.75987C15.5197 12.039 12.039 15.5197 7.75987 15.5197ZM7.75987 1.90911C4.53381 1.90911 1.90911 4.53381 1.90911 7.75855C1.90911 10.9833 4.53381 13.608 7.75987 13.608C10.9859 13.608 13.6106 10.9833 13.6106 7.75855C13.6106 4.53381 10.9859 1.91042 7.75987 1.91042V1.90911Z"></path>
              <path d="M16.8235 17.9987C16.5228 17.9987 16.2221 17.8845 15.9924 17.6547L11.9378 13.6001C11.4783 13.1406 11.4783 12.3974 11.9378 11.9379C12.3974 11.4783 13.1418 11.4783 13.6001 11.9379L17.6546 15.9924C18.1142 16.452 18.1142 17.1951 17.6546 17.6547C17.4249 17.8845 17.1242 17.9987 16.8235 17.9987Z"></path>
            </g>
          </svg>
        </div>
      </div>
      <div>
        <p className='text-[20px] mb-4 font-bold'>Recent Posts</p>
        <div className='flex flex-col gap-2'>
          <a href="/" className="hover:text-blue-700">Why Traditional Token Launches Fail (and How LoadCoin Revolutionizes Crypto Projects)?</a>
          {/* <a href="/" className="hover:text-blue-700">how Can I Promote My Crypto Project Organically</a> */}
        </div>
      </div>
      <div>
        <p className='text-[20px] mb-4 font-bold'>Recent Comments</p>
        <p className="mb-10">No comments to show.</p>
        <div className="relative w-full lg:w-64">
          <input
            className="w-full p-3 pl-10 rounded-lg focus:outline-none"
            placeholder="Search"
            // onChange={onSearchChanged}
            style={{
              background: 'var(--input-bg)',
              border: '1px solid var(--input-border)',
              color: 'var(--text-primary)'
            }}
          />
          <svg
            className="absolute left-3 top-3.5 w-5 h-5"
            style={{ color: 'var(--text-secondary)' }}
            fill="currentColor"
            viewBox="0 0 18 18"
          >
            <g>
              <path d="M7.75987 15.5197C3.48078 15.5197 0 12.039 0 7.75987C0 3.48078 3.48078 0 7.75987 0C12.039 0 15.5197 3.48078 15.5197 7.75987C15.5197 12.039 12.039 15.5197 7.75987 15.5197ZM7.75987 1.90911C4.53381 1.90911 1.90911 4.53381 1.90911 7.75855C1.90911 10.9833 4.53381 13.608 7.75987 13.608C10.9859 13.608 13.6106 10.9833 13.6106 7.75855C13.6106 4.53381 10.9859 1.91042 7.75987 1.91042V1.90911Z"></path>
              <path d="M16.8235 17.9987C16.5228 17.9987 16.2221 17.8845 15.9924 17.6547L11.9378 13.6001C11.4783 13.1406 11.4783 12.3974 11.9378 11.9379C12.3974 11.4783 13.1418 11.4783 13.6001 11.9379L17.6546 15.9924C18.1142 16.452 18.1142 17.1951 17.6546 17.6547C17.4249 17.8845 17.1242 17.9987 16.8235 17.9987Z"></path>
            </g>
          </svg>
        </div>
      </div>
      <div >
        <p className='text-[20px] mb-4 font-bold'>Recent post</p>
        <div className="space-y-2">
          <div className='flex flex-row gap-4 items-center'>
            <div className="w-1/3">
              <a href="/"><img src="img/1/1.png" alt="img1" className="border rounded-lg border-none h-20" /></a>
            </div>
            <div className="w-2/3">
              <div className="flex items-center gap-2">
                <Calendar className='w-4 h-4 text-purple-500' />
                <p>August 11, 2025</p>
              </div>
              <p className="font-bold">What Are the Best Crypto Marketing</p>
            </div>
          </div>
          {/* <div className='flex flex-row gap-4 items-center'>
            <div className="w-1/3">
              <a href="/"><img src="https://bullshill.com/wp-content/uploads/2025/08/The-Best-Crypto-Marketing-Strategies.png" alt="img1" className="border rounded-lg border-none h-20" /></a>
            </div>
            <div className="w-2/3">
              <p>August 9, 2025</p>
              <p className="font-bold">How Can I Promote My Crypto</p>
            </div>
          </div> */}
        </div>
      </div>
      <div>
        <p className='text-[20px] mb-4 font-bold'>Categories</p>
        <div className="space-y-4">
          <div className="flex flex-row justify-between">
            <a href="" className="hover:text-blue-700 ">Airdrop Campaigns</a>
            <span>(1)</span>
          </div>
          <div className="flex flex-row justify-between">
            <a href="" className="hover:text-blue-700 ">Blockchain Basics</a>
            <span>(1)</span>
          </div>
        </div>
      </div>
      <div>
        <p className='text-[20px] mb-4 font-bold'>Tag Cloud</p>
        <div className="flex flex-col space-y-2">
          <a href=""><p className="border-2 px-4 py-2 hover:bg-blue-700 inline-block rounded-md">Airdrop Conversion Strategy</p></a>
          <a href=""><p className="border-2 px-4 py-2 hover:bg-blue-700 inline-block rounded-md">Airdrop Viral Growth</p></a>
        </div>
      </div>
    </div>
  )
}

export default BlogRight;